import type { ItemCacheLockId } from '../store/schema/ItemCacheLockId';

let nextLockIdNum = 0;
export function createItemCacheLockId(): ItemCacheLockId {
    const lockId = `item_cache_lock_${nextLockIdNum}`;
    nextLockIdNum++;

    return lockId as ItemCacheLockId;
}
